import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { SupplierMapping, Unit } from '@synergy/models';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';

export const CLEAR_SUPPLIER_UNIT_MAPPINGS = 'CLEAR_SUPPLIER_UNIT_MAPPINGS';
export const RECEIVE_SUPPLIER_UNIT_MAPPING = 'RECEIVE_SUPPLIER_UNIT_MAPPING';
export const RECEIVE_SUPPLIER_UNIT_MAPPINGS = 'RECEIVE_SUPPLIER_UNIT_MAPPINGS';

const receiveSupplierUnitMappings = (supplierMappings: PaginatedResponse<SupplierMapping<Unit>>) => {
    return {
        type: RECEIVE_SUPPLIER_UNIT_MAPPINGS,
        supplierMappings,
    };
};

const receiveSupplierUnitMapping = (supplierMapping: SupplierMapping<Unit>) => {
    return {
        type: RECEIVE_SUPPLIER_UNIT_MAPPING,
        supplierMapping,
    };
};

export const clearSupplierUnitMappings = () => {
    return {
        type: CLEAR_SUPPLIER_UNIT_MAPPINGS,
    };
};

export const fetchSupplierUnitMapping = (supplierId: number, searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.UnitMapping.getUnitMapping(
            supplierId,
            searchParams
        );

        if (response.success) {
            dispatch(receiveSupplierUnitMappings(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateSupplierUnitMapping = (supplierId: number, supplierMapping: SupplierMapping<Unit>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.UnitMapping.updateUnitMapping(
            supplierId,
            supplierMapping
        );

        if (response.success) {
            dispatch(receiveSupplierUnitMapping(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
